import {type SupportedLocales, useLocale} from '@/lib/locale/locale'
import type {MinimalCartItem, StripeAddress} from '@/lib/payment/paymenModel'
import {getTax} from '@/lib/payment/paymentService'
import {NO_REFETCH_OPTIONS} from '@/utils/query/constants'

export function getTaxQueryKey({
  address,
  lineItems,
  locale,
}: {
  address?: StripeAddress
  lineItems?: MinimalCartItem[]
  locale: SupportedLocales
}) {
  return ['tax', locale, address, lineItems] as const
}

export function getTaxQueryOptions({
  address,
  lineItems,
  locale,
}: {
  address?: StripeAddress
  lineItems?: MinimalCartItem[]
  locale: SupportedLocales
}) {
  return queryOptions({
    queryKey: getTaxQueryKey({address, lineItems, locale}),
    queryFn:
      !!address && lineItems && lineItems.length > 0
        ? async () => getTax({address, lineItems, locale})
        : skipToken,
    ...NO_REFETCH_OPTIONS,
  })
}

export default function useTax({
  address,
  lineItems,
}: {
  address?: StripeAddress
  lineItems?: MinimalCartItem[]
}) {
  const [locale] = useLocale()
  return useQuery(getTaxQueryOptions({address, lineItems, locale}))
}
